import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { csSubmitDocs } from "../../api/verify.api";
import { csSession } from "../../auth/session";
import styles from "../../styles/login.module.css";
import { uploadToImgbb } from "../../utils/imgbb";

export default function SubmitDocs() {
  const nav = useNavigate();
  const phone = csSession.getPhone();

  const [files, setFiles] = useState({
    profile: null,
    idFront: null,
    idBack: null,
  });

  const [previews, setPreviews] = useState({
    profile: "",
    idFront: "",
    idBack: "",
  });

  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState("");
  const [step, setStep] = useState(""); // "Uploading profile..." etc.

  useEffect(() => {
    if (!phone) nav("/couriersub/login");
  }, [phone, nav]);

  // preview url-ları
  useEffect(() => {
    const next = { profile: "", idFront: "", idBack: "" };

    for (const k of Object.keys(files)) {
      if (files[k]) next[k] = URL.createObjectURL(files[k]);
    }

    setPreviews(next);

    return () => {
      for (const k of Object.keys(next)) {
        if (next[k]) URL.revokeObjectURL(next[k]);
      }
    };
  }, [files]);

  const canSubmit = useMemo(() => {
    return !!files.profile && !!files.idFront && !!files.idBack && !loading;
  }, [files, loading]);

  const pick = (key) => (e) => {
    const f = e.target.files?.[0] || null;
    setFiles((p) => ({ ...p, [key]: f }));
  };

  const submit = async (e) => {
    e?.preventDefault?.();
    if (!canSubmit) {
      return setMsg("Zəhmət olmasa 3 sənədi də seçin.");
    }

    setMsg("");
    setLoading(true);

    try {
      // 1) upload profile
      setStep("Profil şəkli yüklənir...");
      const profileImageUrl = await uploadToImgbb(files.profile);

      // 2) upload id front
      setStep("Ş/V ön tərəf yüklənir...");
      const idFrontUrl = await uploadToImgbb(files.idFront);

      // 3) upload id back
      setStep("Ş/V arxa tərəf yüklənir...");
      const idBackUrl = await uploadToImgbb(files.idBack);

      setStep("Sənədlər göndərilir...");
      await csSubmitDocs({
        phone,
        profileImageUrl,
        idFrontUrl,
        idBackUrl,
      });

      nav("/couriersub/dashboard");
    } catch (err) {
      const apiMsg =
        err?.response?.data?.message ||
        err?.response?.data?.error ||
        err?.message ||
        "Sənədlər göndərilmədi.";
      setMsg(apiMsg);
    } finally {
      setLoading(false);
      setStep("");
    }
  };

  return (
    <div className={styles.page}>
      <div className={styles.card}>
        <div className={styles.header}>
          <div className={styles.brand}>MotoTaksi.az</div>
          <h1 className={styles.title}>Sənədlərin Yüklənməsi</h1>
          <p className={styles.subtitle}>
            Zəhmət olmasa profil şəkli və şəxsiyyət vəsiqəsinin ön/arxa şəklini seçin.
          </p>
        </div>

        <form className={styles.form} onSubmit={submit}>
          <div className={styles.docGrid}>
            <DocPicker
              title="Profil şəkli"
              hint="Selfie / profil foto (kamera ilə çək)"
              preview={previews.profile}
              disabled={loading}
              onPick={pick("profile")}
              cameraOnly
              captureMode="user"   // ön kamera
            />

            <DocPicker
              title="Ş/V ön tərəf"
              hint="Şəxsiyyət vəsiqəsi (ön)"
              preview={previews.idFront}
              disabled={loading}
              onPick={pick("idFront")}
            />
            <DocPicker
              title="Ş/V arxa tərəf"
              hint="Şəxsiyyət vəsiqəsi (arxa)"
              preview={previews.idBack}
              disabled={loading}
              onPick={pick("idBack")}
            />
          </div>

          <button className={styles.btn} type="submit" disabled={!canSubmit}>
            {loading ? "Yüklənir..." : "Göndər"}
          </button>

          {loading && step && <div className={styles.info}>{step}</div>}
          {msg && <div className={styles.error}>{msg}</div>}
        </form>
      </div>
    </div>
  );
}

function DocPicker({ title, hint, preview, onPick, disabled, cameraOnly, captureMode }) {
  return (
    <div style={{ display: "grid", gap: 8 }}>
      <div style={{ fontSize: 12, fontWeight: 800, color: "#6b7280" }}>{title}</div>

      <div
        style={{
          width: "100%",
          height: 120,
          borderRadius: 12,
          border: "1px solid #e5e7eb",
          background: "#fff",
          overflow: "hidden",
          display: "grid",
          placeItems: "center",
        }}
      >
        {preview ? (
          <img
            src={preview}
            alt={title}
            style={{ width: "100%", height: "100%", objectFit: "cover" }}
          />
        ) : (
          <div style={{ color: "#9ca3af", fontSize: 13, textAlign: "center", padding: 10 }}>
            {hint}
          </div>
        )}
      </div>

      <input
        type="file"
        accept="image/*"
        onChange={onPick}
        disabled={disabled}
        capture={cameraOnly ? (captureMode || "user") : undefined}
        style={{ width: "100%", fontSize: 13 }}
      />

      {cameraOnly && (
        <div style={{ fontSize: 12, color: "#6b7280" }}>
          Qeyd: Profil şəkli yalnız kamera ilə çəkilərək əlavə olunur.
        </div>
      )}
    </div>
  );
}


